import * as firebase from 'firebase';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/observable';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class AuthService {
    token:string;
    userauth:boolean;
    adminauth:boolean;
    loading:boolean;
    adminChange2=new Subject();

    constructor(private router:Router,public flashMessagesService: FlashMessagesService){}
    signupUser(name:string,email:string,password:string){
        return new Promise((resolve,reject)=>{
        firebase.auth().createUserWithEmailAndPassword(email,password)
        .then((res)=>{
            let user:any = firebase.auth().currentUser;
            user.sendEmailVerification().then(
              (success) => {
              this.flashMessagesService.show('Check email and verify Email',{cssClass:'alert-success',timeout:6000});
            } 
            ).catch(
              (err) => {
                this.flashMessagesService.show(err.message,{cssClass:'alert-danger',timeout:3000});
              }
            )
            res.updateProfile({
                displayName:name,
              })
            // this.flashMessagesService.show('New user registered',{cssClass:'alert-success',timeout:3000});
            this.router.navigate(['/signin']);
          },err=>reject(err))
          .catch((err)=>{
            this.flashMessagesService.show(err.message,{cssClass:'alert-danger',timeout:3000});
            this.router.navigate(['/signup']);
          });
          
            
          });
    }
    signinUser(email:string,password:string){
        firebase.auth().signInWithEmailAndPassword(email,password)
        .then(
            response=> {
                if(response.emailVerified || response.uid=='FTzCUkaxQxaKmISWlKQQOpo2ZHh2') {
                    // Redirect the user here
                    this.router.navigate(['/']);
                    localStorage.setItem("user", firebase.auth().currentUser.uid);
                    localStorage.setItem("name", firebase.auth().currentUser.displayName);
                    if((localStorage.getItem('user')=='FTzCUkaxQxaKmISWlKQQOpo2ZHh2') || (localStorage.getItem('user')=='dH6SQbCzhKYOK7dmIJAgJ5P0Xbx2')){
                        this.adminauth=true;
                        console.log(this.adminauth);
                    }
                    else{
                        this.userauth=true;
                    }
                    firebase.auth().currentUser.getToken()
                    .then(
                        (token:string) =>{
                            localStorage.setItem('token',token);
                        }
                    )

                  } else {

                    // Tell the user to have a look at its mailbox
                    this.flashMessagesService.show('Email not verified.Check email',{cssClass:'alert-success',timeout:6000});
                    this.router.navigate(['/']); 
                  }
                // this.router.navigate(['/']);
                // localStorage.setItem("user", firebase.auth().currentUser.uid);
                // localStorage.setItem("name", firebase.auth().currentUser.displayName);
                // if((localStorage.getItem('user')=='FTzCUkaxQxaKmISWlKQQOpo2ZHh2') || (localStorage.getItem('user')=='dH6SQbCzhKYOK7dmIJAgJ5P0Xbx2')){
                //     this.adminauth=true;
                //     console.log(this.adminauth);
                // }
                // else{
                //     this.userauth=true;
                // }
                // firebase.auth().currentUser.getToken()
                // .then(
                //     (token:string) =>{
                //         localStorage.setItem('token',token);
                //     }
                // )
            }
        )
        .catch((err)=>{
            this.flashMessagesService.show(err.message,{cssClass:'alert-danger',timeout:4000});
            this.router.navigate(['/signin']);
          });

          return new Promise((resolve,reject)=>{
            firebase.auth().signInWithEmailAndPassword(email,password)
            .then(userData=>resolve(userData),
          err=>reject(err));
          });
        
        
    }
    resetPassword(email: string) {
       
        firebase.auth().sendPasswordResetEmail(email)
          .then(() => {
            this.flashMessagesService.show('Password reset email has been sent.',{cssClass:'alert-success',timeout:6000});
            this.router.navigate(['/signin']);
          })
          .catch((error) => {
            this.flashMessagesService.show(error.message,{cssClass:'alert-danger',timeout:8000});
          });
          return new Promise((resolve,reject)=>{
            firebase.auth().sendPasswordResetEmail(email)
            .then(userData=>resolve(userData),
          err=>reject(err));
          });
      }
    logout(){
        firebase.auth().signOut();
        //this.token=null;
        this.adminauth=false;
        this.userauth=false;
        localStorage.clear();
    }
    getToken(){
        // firebase.auth().currentUser.getToken()
        // .then(
        //     (token:string) =>this.token=token
        // );
        

        // return this.token;
        return localStorage.getItem('token');
    }
    isAuthenticated(){
        //console.log(this.token);
        // return this.token != null;
        // if(localStorage.getItem('user')=='FTzCUkaxQxaKmISWlKQQOpo2ZHh2'){
        //     this.adminauth=true;
        //     console.log(this.adminauth);
        // }
        // else{
        //     this.userauth=true;
        // }
       return localStorage.getItem('token') != null;
    }
    adminChange(admin){
        this.adminChange2.next(admin);
    }
}



// WEBPACK FOOTER //
// G:/phoneinfo2/phoneinfo/src/app/auth/auth.service.ts